const getSetImagePath = function(rootUrl, setImagePath) {
  return rootUrl.endsWith('/')
    ? `${rootUrl}${setImagePath}?r=${parseInt(Math.random() * 1000)}`
    : `${rootUrl}/${setImagePath}?r=${parseInt(Math.random() * 1000)}`;
};

export default {
  getImagePath: getSetImagePath
};
